<template>
  <el-aside class="s_layout_sidebar" :width="isCollapse ? '60px' : '200px'">
    <div class="s-layout-sidebar-logo">
      <img class="s-layout-sidebar-img" :src="$global.adminUser.avatar" />
    </div>
    <div class="s-layout-sidebar-status g-flex-justify-center g-flex-align-center" @mouseenter="statusSelectShow = true" @mouseleave="statusSelectShow = false">
      <label class="s-status-label" :class="status === 2 ? 's-no-active' : 's-active'"></label>
      <span class="s-status-text">{{currentStatusTitle}}</span>
      <div class="s-status-select" v-show="statusSelectShow">
        <p v-for="(item, index) in statusList" :key="index" @click="statusClick(item)">{{item.title}}</p>
      </div>
    </div>
    <el-scrollbar style="height: calc(100% - 100px);">
      <el-menu tag="div" mode="vertical" :default-active="$route.path" :collapse-transition="false" @select="menuActive" :collapse="isCollapse" :background-color="menuBg" :text-color="menuText" :active-text-color="menuActiveText">
        <LayoutSidebarItem v-for="menu in MenuList" :key="menu.id" :item="menu" :base-path="'/'+menu.path"/>
      </el-menu>
    </el-scrollbar>
  </el-aside>
</template>

<script>
import { menuBg, menuText, menuActiveText } from "@/assets/css/export.scss";
import LayoutSidebarItem from "./LayoutSidebarItem.vue";
import { apiSetStatus } from '@/utils/api.js';
export default {
  name: "LayoutSidebar",
  components: {
    LayoutSidebarItem,
  },
  props: {
    //左侧菜单栏收缩
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentStatusTitle() {
      // 在 JS 中可以安全使用 ?. 语法（前提是你的 Babel 配置支持）
      const found = this.statusList.find(item => item.status === this.status);
      return found ? found.title : '';
    }
  },
  data() {
    return {
      statusSelectShow: false,

      status: this.$global.adminUser.status,

      statusList: [
        { title: '在线', status: 1 },
        { title: '隐身', status: 2 },
        { title: '永久', status: 3 }
      ],
      //左侧菜单栏收缩
      menuBg: menuBg,
      menuText: menuText,
      menuActiveText: menuActiveText,
      user: {
        user_name: "",
      },

      MenuList: this.$global.MenuList
    };
  },
  created() {
  },
  methods: {
    async statusClick(item) {
      let loading = this.$loading()
      const { success, data } = await apiSetStatus({ status: item.status }).catch(() => { loading.close(); return false; })
      loading.close()
      if(!success) return
      // console.log(data)
      this.$message.success(data.msg)
      this.status = item.status
      this.$global.adminUser.status = item.status
      this.statusSelectShow = false
    },

    menuActive(index) {
      // console.log(index)
      if (this.$global.isExternal(index)) {
        window.open(index, "_blank");
      } else {
        this.$router.push(index).catch(() => {
          //重复路由跳转刷新
          this.$router.push("/refresh");
        });
      }
    },
  },
};
</script>

<style lang="scss">
.s_layout_sidebar {
  transition: width 0.28s;
  &.el-aside {
    background-color: $menuBg;
  }
  .el-menu {
    border: none;
  }
  .el-menu--collapse {
    width: 60px;
    .el-submenu__title span {
      height: 0;
      width: 0;
      overflow: hidden;
      visibility: hidden;
      display: inline-block;
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .s-layout-sidebar-logo {
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    // background: $menuTitleBg;
    text-align: center;
    overflow: hidden;
    .s-layout-sidebar-img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      border-radius: 50%;
      object-fit: cover;
    }
  }
  .s-layout-sidebar-status {
    font-size: $small-more-font-size;
    color: $white;
    height: 40px;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    .s-status-label {
      border-radius: 50%;
      width: 8px;
      height: 8px;
      margin-right: 4px;
      &.s-active {
        background: rgb(21, 194, 146);
      }
      &.s-no-active {
        background: red;
      }
    }

    .s-status-select {
      width: 75%;
      border-radius: 4px;
      text-align: center;
      bottom: 0;
      transform: translateY(100%);
      z-index: 9999;
      position: absolute;
      background: $white;
      color: $black;
      p {
        font-size: $most-font-size;
        border-radius: 4px;
        padding: 12px 4px;
        &:hover {
          background: rgb(237, 245, 255);
        }
      }
    }
  }
  .s-layout-sidebar-title {
    display: inline-block;
    font-weight: 600;
    vertical-align: middle;
    margin: 0 0 0 12px;
    max-width: 150px;
  }
}
</style>
